import React from "react";
import {
  FaPaintBrush,
  FaLayerGroup,
  FaFileContract,
  FaSearch,
  FaGavel,
  FaWallet,
  FaCoins,
  FaShieldAlt,
} from "react-icons/fa";

function GlimpseOFOurNFT() {
  const services = [
    {
      icon: <FaPaintBrush />,
      title: "Custom Marketplace Design",
      desc: "We design a fully branded, user-friendly NFT marketplace that reflects your vision and resonates with your target audience. Our custom design solutions ensure a smooth experience for both buyers and sellers.",
    },
    {
      icon: <FaLayerGroup />,
      title: "Multi-Blockchain Support",
      desc: "Our marketplaces are built with multi-chain compatibility, allowing support for Ethereum, Binance Smart Chain, Solana, Polygon, and more. This enables greater flexibility and broader reach for your marketplace.",
    },
    {
      icon: <FaFileContract />,
      title: "Smart Contract Integration",
      desc: "SeWe develop and integrate secure, self-executing smart contracts that automate the creation, minting, trading, and auctioning of NFTs, ensuring transparency, security, and tamper-proof transactions.",
    },
    {
      icon: <FaSearch />,
      title: "Advanced Search & Filtering",
      desc: "Provide your users with intuitive tools for discovering NFTs. Our advanced search and filtering features enhance navigation, making it easier for users to explore, purchase, or sell NFTs within specific categories.",
    },
    {
      icon: <FaGavel />,
      title: "Auction & Bidding System",
      desc: "ReEnable dynamic pricing and competitive buying through integrated auction and bidding features, giving users multiple options for acquiring NFTs.",
    },
    {
      icon: <FaWallet />,
      title: "Wallet Integration",
      desc: "Seamless integration with popular crypto wallets (e.g., MetaMask, Trust Wallet, Coinbase) for secure transactions and asset management. This makes it easy for users to store and manage their NFTs directly within your platform.",
    },
    {
      icon: <FaCoins />,
      title: "Royalties & Revenue",
      desc: "Implement custom royalty systems that ensure creators continue to earn on secondary sales. We also integrate diverse revenue models such as listing fees, transaction fees, and commissions to maximize profitability.",
    },
    {
      icon: <FaShieldAlt />,
      title: "High-Level Security",
      desc: "We employ advanced security protocols including two-factor authentication (2FA), encryption, and smart contract audits to safeguard your platform and user assets.",
    },
  ];

  return (
    <div className="default-padding" style={{ background: "#f8fafc" }}>
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h4 className="sub-title text-primary">Services</h4>
          <h2 className="title">NFT Marketplace Development Services</h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "650px" }}>
            Build powerful, scalable, and secure NFT marketplaces with modern UI
            and seamless user experience.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {services.map((item, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="nft-card p-4 h-100 text-center">
                <div className="icon-box mx-auto mb-3">{item.icon}</div>

                <h2 className="text-bold">{item.title}</h2>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .nft-card {
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #e2e8f0;
          transition: all 0.35s ease;
          position: relative;
          overflow: hidden;
        }

        .nft-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.08);
        }

        .icon-box {
          width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(59,130,246,0.1);
          color: #3b82f6;
          border-radius: 18px;
          font-size: 26px;
          transition: 0.3s;
        }

        .nft-card:hover .icon-box {
          background: #3b82f6;
          color: #fff;
          transform: scale(1.1);
        }

        h5 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        p {
          font-size: 14px;
          color: #64748b;
          margin: 0;
          line-height: 1.6;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .icon-box {
            width: 60px;
            height: 60px;
          }
        }
      `}</style>
    </div>
  );
}

export default GlimpseOFOurNFT;
